const Menu = [
  {
    title: '동의서 관리',
    group: 'agreements',
    path: '/agreements',
  },
  {
    title: '동의서 형식 신규',
    group: '/templates',
    path: '/templates/new',
  },
  {
    title: '동의서 형식 편집',
    path: '/templates',
    group: '/templates',
  },
  {
    title: '설정',
    group: 'settings',
    path: '/settings',
    children: [
      {
        title: '조직',
        group: 'settings',
        path: '/settings/organizations',
      },
      {
        title: '조회',
        group: 'settings',
        path: '/settings/users',
      },
      {
        title: '문서관리',
        group: 'settings',
        path: '/settings/documents',
      },
      {
        title: '연동',
        group: 'settings',
        path: '/settings/apis',
      },
    ],
  },
]

export default Menu



// WEBPACK FOOTER //
// ./src/api/menu.js